import request from '@/utils/request'


// 查询用户积分时间规则列表
export function listUserScoreTimeRule(query) {
  return request({
    url: '/biz/admin/user/score/time/rule/list',
    method: 'get',
    params: query
  })
}

// 查询用户积分时间规则分页
export function pageUserScoreTimeRule(query) {
  return request({
    url: '/biz/admin/user/score/time/rule/page',
    method: 'get',
    params: query
  })
}

// 查询用户积分时间规则详细
export function getUserScoreTimeRule(data) {
  return request({
    url: '/biz/admin/user/score/time/rule/detail',
    method: 'get',
    params: data
  })
}

// 新增用户积分时间规则
export function addUserScoreTimeRule(data) {
  return request({
    url: '/biz/admin/user/score/time/rule/add',
    method: 'post',
    data: data
  })
}

// 修改用户积分时间规则
export function updateUserScoreTimeRule(data) {
  return request({
    url: '/biz/admin/user/score/time/rule/edit',
    method: 'post',
    data: data
  })
}

// 删除用户积分时间规则
export function delUserScoreTimeRule(data) {
  return request({
    url: '/biz/admin/user/score/time/rule/delete',
    method: 'post',
    data: data
  })
}


export function getUserScoreSignRule() {
  return request({
    url: '/biz/admin/user/score/sign/rule/detail',
    method: 'get',
  })
}


export function saveUserScoreSignRule(data) {
  return request({
    url: '/biz/admin/user/score/sign/rule/save',
    method: 'post',
    data: data
  })
}
